import { tidSelector } from "shared/util/selectors";
import { TEST_IDS } from "shared/ComplianceToolsDropdown/test-ids";

const { COMPLIANCE_TOOLS_DROPDOWN } = TEST_IDS;

export const SELECTORS = {
    COMPLIANCE_TOOLS_DROPDOWN: tidSelector(COMPLIANCE_TOOLS_DROPDOWN),
};
